export default "__VITE_ASSET__xhHROGXM__"